const pdRouter = [
  {
    name: 'SearchType',
    path: '*/searchType/:type/:isRecovery/:keyword?',
    component: () => import('@/views/search/reportDetail/reportDetail'),
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'searchDetail',
    path: '*/searchDetail/:contentid/:typeId/:kgId/:subType?',
    component: () => import('@/views/search/particulars/particulars')
  },
  {
    name: 'fullTopics',
    path: '*/graph/:type',
    component: () => import('@/views/topics/FullTopics'),
    meta: {
      keepAlive: true
    }
  }
]
export default pdRouter
